import React, { useState, useEffect } from "react";
import { Box, Typography, Alert, Breadcrumbs } from "@mui/material";
import ContestsList from "./components/ContestsList";
import MyContestList from "./components/MyContestList";
import { Contest } from "../../api/contest";
import { useAlert } from "@/contexts/AlertContext";
import { useNavigate } from 'react-router-dom';
import { useCustomBreadcrumb } from "@/contexts/CustomBreadcrumb";
import { registerContest } from '@/api/contestApi';
import { useSnackbar } from 'notistack';

const MyContestsPage = () => {
  const [contestData, setContestData] = useState(null);
  const [error, setError] = useState<{message: string, type: string} | null>(null);
  const alert = useAlert();
  const navigate = useNavigate();
  const customBreadcrumb=useCustomBreadcrumb();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContests();
  }, []);

  const fetchContests = async () => {
    try {
      setLoading(true);
      const response = await Contest.getContests();
      
      if (response.errorType) {
        setError({
          message: response.message,
          type: response.errorType
        });
        setContestData(null);
      } else {
        setError(null);
        setContestData(response);
      }
    } catch (error) {
      console.error("Error fetching contests:", error);
      setError({
        message: "Đã xảy ra lỗi khi tải danh sách cuộc thi",
        type: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleContinueContest = (contest) => {
    console.log("contest", contest);
    customBreadcrumb.addBreadcrumbRule({
      path: `${process.env.PREFIX}/my-contests/${contest.id}`,
      breadcrumb: contest.title
    });
    navigate(`./${contest.id}`);
  };

  const handleRegisterContest = async (contest) => {
    try {
      const response = await Contest.registerContest(contest.id);
      if (response.status) {
        setContestData((prevContests) => {
          console.log("prevContests", prevContests);
          if (!prevContests || !prevContests.contest || !Array.isArray(prevContests.contest.data)) return prevContests;
          return {
            ...prevContests,
            contest: {
              ...prevContests.contest,
              data: prevContests.contest.data.map(c =>
                c.id === contest.id 
                  ? { ...c, participation_status: 0 } 
                  : c
              )
            }
          };
        });
        enqueueSnackbar('Registration request sent successfully', { variant: 'success' });
      }
    } catch (error) {
      console.error('Error registering for contest:', error);
      enqueueSnackbar('Failed to register for contest', { variant: 'error' });
    }
  };

  return (
    <Box>
      <Box sx={{ p: 3, bgcolor: "white", borderRadius: 2, boxShadow: 1, mb: 3 }}>
        <ContestsList
          contestData={contestData}
          error={error}
          loading={loading}
          onContinueContest={handleContinueContest}
          onRegisterContest={handleRegisterContest}
        />
      </Box>

      <Box sx={{ p: 3, bgcolor: "white", borderRadius: 2, boxShadow: 1 }}>
        <MyContestList />
      </Box>
    </Box>
  );
};

export default MyContestsPage; 